const getEventRegEnabled = (event) => {
	const now = new Date().getTime();
	const regEnabled = event?.options?.reg?.startTs < now && event?.options?.reg?.endTs > now;
	const isPublic = !(event?.options?.reg?.private);
	return regEnabled && isPublic;
};

export {
	getEventRegEnabled
};